/** Статусы путевого листа (строки совпадают с JSON API). */
export enum WaybillStatus {
    Undefined = "Undefined",
    Pending = "Pending",
    Matched = "Matched",
    Processing = "Processing",
    Processed = "Processed",
    Error = "Error",
}

export const WaybillStatusUtil = {
    getLabel: (value: WaybillStatus | string | null | undefined): string => {
        switch (value) {
            case WaybillStatus.Pending:
                return "Ожидает обработки";
            case WaybillStatus.Matched:
            case WaybillStatus.Processing:
                return "Обрабатывается";
            case WaybillStatus.Error:
                return "Ошибка обработки";
            case WaybillStatus.Processed:
            case WaybillStatus.Undefined:
                return "Обработан";
            default:
                return "Обработан";
        }
    },

    /** Кнопки «Допуск» / «Недопуск» доступны при повторном подписании. */
    isActionable: (value: WaybillStatus | string | null | undefined): boolean =>
        value === WaybillStatus.Pending ||
        value === WaybillStatus.Error,
};
